import type {CompositeMonorailEvent} from '@shopify/monorail/lib/events/events';

class ShopifyAnalyticsNotAvailableError extends Error {
  constructor() {
    super('ShopifyAnalytics not available');
  }
}

export const emitMonorailEventThroughTrekkie = (
  event: CompositeMonorailEvent,
): Promise<void> => {
  let timer: NodeJS.Timeout;

  const promise = Promise.race<void>([
    new Promise(
      (_resolve, reject) =>
        (timer = setTimeout(
          () => reject(new ShopifyAnalyticsNotAvailableError()),
          10000,
        )),
    ),
    new Promise((resolve, reject) => {
      const shopifyAnalytics = window.ShopifyAnalytics?.lib;

      if (shopifyAnalytics && shopifyAnalytics.ready) {
        shopifyAnalytics.ready(() => {
          if (!window.ShopifyAnalytics?.lib?.track) {
            reject(new ShopifyAnalyticsNotAvailableError());
            return;
          }

          resolve(
            window.ShopifyAnalytics.lib.track(
              `monorail://${event.schemaId}`,
              convertCamelCasedKeysToSnakeCase(event.payload),
            ),
          );
        });

        return;
      }

      reject(new ShopifyAnalyticsNotAvailableError());
    }),
  ]);
  return promise
    .catch((error) => {
      if (!(error instanceof ShopifyAnalyticsNotAvailableError)) {
        // Ordinarily we would emit an error to bugsnag here, but Bugsnag would add a lot of bloat to the bundle.
        // Ideally Bugsnag/Monorail/Opentel could be a shared service across all bundles on a page, but that's a larger refactor.
        // eslint-disable-next-line no-console
        console.log(`[shop-js] Error emitting monorail event`, error);
      }
    })
    .finally(() => clearTimeout(timer));
};

const convertCamelCasedKeysToSnakeCase = (payload: Record<string, any>) =>
  Object.keys(payload).reduce(
    (acc, key) => ({
      ...acc,
      [key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)]:
        payload[key],
    }),
    {},
  );
